import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PrintIcon from '@material-ui/icons/Print';
import DescriptionIcon from '@material-ui/icons/Description';
import SearchArea from './SearchArea';
import GeneralService from '../apis/GeneralService';
import { Panel } from 'primereact/panel';
import moment from 'moment';
import { NotificationManager } from 'react-notifications';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#3C8DBC",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
}

const rows = [
    createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
    createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
    createData('Eclair', 262, 16.0, 24, 6.0),
    createData('Cupcake', 305, 3.7, 67, 4.3),
    createData('Gingerbread', 356, 16.0, 49, 3.9),
];

const useStyles = makeStyles({
    table: {
        minWidth: 700,
    },
    printButton: {
        marginBottom: '20px',
        backgroundColor: '#3C8DBC',
        color: 'white',
        '&:hover': {
            backgroundColor: '#2C7DAC',
        },
    },
    selectedFormContainer: {
        marginBottom: '20px',
        padding: '20px',
        backgroundColor: '#f5f5f5',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    formInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
});

// Lista de formularios disponibles con sus siglas
const formularios = [
    { id: 1, nombre: 'ANT cambio de socio y vehiculo.pdf', sigla: 'SCSV', archivo: 'ANT cambio de socio y vehiculo.pdf' },
    { id: 2, nombre: 'ANT cambio de vehiculo.pdf', sigla: 'SCV', archivo: 'ANT cambio de vehiculo.pdf' },
    { id: 3, nombre: 'ANT cambio socio.pdf', sigla: 'SCS', archivo: 'ANT cambio socio.pdf' },
    { id: 4, nombre: 'ANT constitucion juridica.pdf', sigla: 'SCJ', archivo: 'ANT constitucion juridica.pdf' },
    { id: 5, nombre: 'ANT deshabilitacion de vehiculo.pdf', sigla: 'SDV', archivo: 'ANT deshabilitacion de vehiculo.pdf' },
    { id: 6, nombre: 'ANT habilitacion de vehiculo.pdf', sigla: 'SHV', archivo: 'ANT habilitacion de vehiculo.pdf' },
    { id: 7, nombre: 'ANT permiso de operación.pdf', sigla: 'SCPO', archivo: 'ANT permiso de operacion.pdf' },
    { id: 8, nombre: 'ANT renovacion permisos operacion.pdf', sigla: 'SRPO', archivo: 'ANT renovacion permisos operacion.pdf' },
    { id: 9, nombre: 'Aviso Alcabalas.pdf', sigla: 'AVA', archivo: 'Aviso Alcabalas.pdf' },
    { id: 10, nombre: 'Certificado de no adeudar.pdf', sigla: 'CDNA', archivo: 'Certificado de no adeudar.pdf' },
    { id: 11, nombre: 'Declaracion Activos totales.pdf', sigla: 'SDUM', archivo: 'Declaracion Activos totales.pdf' },
    { id: 12, nombre: 'Declaracion Plusvalia.pdf', sigla: 'SDP', archivo: 'DeclaracionPlusvalia.pdf' },
    { id: 13, nombre: 'Solicitud aprobacion anteproyectos.pdf', sigla: 'SAP', archivo: 'S aprobacion anteproyectos.pdf' },
    { id: 14, nombre: 'Solicitud aprobacion de planos arquitectonicos.pdf', sigla: 'SAPA', archivo: 'S aprobacion de planos arquitectonicos.pdf' },
    { id: 15, nombre: 'Solicitud aprobacion fraccionamientos.pdf', sigla: 'SPF', archivo: 'S aprobacion fraccionamientos.pdf' },
    { id: 16, nombre: 'Solicitud Avaluos y Catastros.pdf', sigla: 'SAC', archivo: 'S Avaluos y Catastros.pdf' },
    { id: 17, nombre: 'Solicitud de reclamos.pdf', sigla: 'FDR', archivo: 'SReclamos.pdf' },
    { id: 18, nombre: 'Solicitud Facilidades de Pago.pdf', sigla: 'SFP', archivo: 'Solicitud Facilidades de Pago.pdf' },
    { id: 19, nombre: 'Solicitud General.pdf', sigla: 'STT', archivo: 'Solicitud General.pdf' },
    { id: 20, nombre: 'Solicitud linea de fabrica.pdf', sigla: 'SLF', archivo: 'S linea de fabrica.pdf' },
    { id: 21, nombre: 'Solicitud permiso de construccion.pdf', sigla: 'SPC', archivo: 'S permiso de construccion.pdf' },
    { id: 22, nombre: 'Solicitud realizacion inspecciones.pdf', sigla: 'SRI', archivo: 'S realizacion inspecciones.pdf' },
    { id: 23, nombre: 'Solicitud servicios cementerios.pdf', sigla: 'SSC', archivo: 'S servicios cementerios.pdf' },
    { id: 24, nombre: 'Solicitud trabajos varios.pdf', sigla: 'STV', archivo: 'S trabajos varios.pdf' },
];

export default function ConsultaDeuda() {
    const classes = useStyles();
    const [showTable, setShowTable] = React.useState(false);
    const [data, setData] = React.useState(null);
    const [toPay, setToPay] = React.useState(0);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [selectedFormulario, setSelectedFormulario] = React.useState(null);
    const [isPrinting, setIsPrinting] = React.useState(false);
    const [identificacion, setIdentificacion] = React.useState(''); // NUEVO: Guardar identificación

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleFormularioSelect = (formulario) => {
        setSelectedFormulario(formulario);
        handleMenuClose();
    };

    const formulariosDisponibles = React.useMemo(() => {
    // Si no hay datos aún, mostrar todos
        if (!data) return formularios;
        
        // Si hay deudas (array con elementos), excluir el certificado de no adeudar
        if (data.length > 0) {
            return formularios.filter(f => f.sigla !== 'CDNA');
        }
        
        // Si no hay deudas (array vacío), mostrar todos incluido el certificado
        return formularios;
    }, [data]);

    const handlePrintFormulario = async () => {
        if (!selectedFormulario) {
            NotificationManager.warning("Por favor seleccione un formulario primero", "", 3000);
            return;
        }

        // NUEVO: Validar que tengamos identificación
        if (!identificacion) {
            NotificationManager.error("No se pudo obtener la identificación del contribuyente", "", 3000);
            return;
        }

        setIsPrinting(true);
        
        try {
            const pdfPath = `${process.env.PUBLIC_URL}/formatos/${selectedFormulario.archivo}`;
            
            console.log('=== INICIO DEBUG ===');
            console.log('Formulario seleccionado:', selectedFormulario);
            console.log('Identificación:', identificacion); // NUEVO: Log de identificación
            console.log('Ruta PDF:', pdfPath);
            
            const response = await fetch(pdfPath);
            
            console.log('Response status:', response.status);
            console.log('Response OK:', response.ok);
            
            if (!response.ok) {
                throw new Error(`No se pudo cargar el archivo PDF. Status: ${response.status}`);
            }
            
            const pdfArrayBuffer = await response.arrayBuffer();
            
            const header = new Uint8Array(pdfArrayBuffer.slice(0, 5));
            const headerString = String.fromCharCode.apply(null, header);
            
            if (!headerString.startsWith('%PDF-')) {
                throw new Error(`El archivo no es un PDF válido. Encabezado: ${headerString}`);
            }
            
            console.log('✓ PDF cargado correctamente');
            console.log('Tamaño:', pdfArrayBuffer.byteLength, 'bytes');
            console.log('Sigla a enviar:', selectedFormulario.sigla);
            console.log('URL del backend:', `${GeneralService.api_url}/cajaunica/rest/caja/pdf/reemplazar?sigla=${selectedFormulario.sigla}&identificacion=${identificacion}`);
            
            // CAMBIO: Enviar al backend con identificación
            const backendResponse = await GeneralService.procesarPdfFormulario(
                pdfArrayBuffer, 
                selectedFormulario.sigla,
                identificacion
            );

            console.log('✓ Backend procesó correctamente');
            console.log('Response data type:', typeof backendResponse.data);
            console.log('Response data size:', backendResponse.data.size);

            const processedPdfBlob = backendResponse.data;
            const pdfUrl = URL.createObjectURL(processedPdfBlob);
            
            const printWindow = window.open(pdfUrl, '_blank');
            
            if (printWindow) {
                printWindow.onload = () => {
                    printWindow.print();
                };
            } else {
                NotificationManager.warning(
                    "No se pudo abrir la ventana de impresión. Verifique que no esté bloqueando ventanas emergentes.", 
                    "", 
                    5000
                );
            }
            
            NotificationManager.success(
                `Formulario ${selectedFormulario.nombre} preparado para imprimir`, 
                "", 
                3000
            );
            
            setTimeout(() => URL.revokeObjectURL(pdfUrl), 10000);
            
        } catch (error) {
            console.error('=== ERROR COMPLETO ===');
            console.error('Error:', error);
            console.error('Error message:', error.message);
            
            // Detalles del error de axios
            if (error.response) {
                console.error('❌ Error del servidor:');
                console.error('Status:', error.response.status);
                console.error('Status Text:', error.response.statusText);
                console.error('Headers:', error.response.headers);
                console.error('Data:', error.response.data);
                
                // Intentar leer el error como texto si es un blob
                if (error.response.data instanceof Blob) {
                    const text = await error.response.data.text();
                    console.error('Error del servidor (texto):', text);
                    NotificationManager.error(
                        `Error del servidor: ${text}`, 
                        "", 
                        7000
                    );
                } else {
                    NotificationManager.error(
                        `Error del servidor (${error.response.status}): ${error.response.data.message || error.response.statusText}`, 
                        "", 
                        7000
                    );
                }
            } else if (error.request) {
                console.error('❌ No hubo respuesta del servidor');
                console.error('Request:', error.request);
                NotificationManager.error(
                    'No se recibió respuesta del servidor', 
                    "", 
                    5000
                );
            } else {
                console.error('❌ Error al configurar la petición');
                NotificationManager.error(
                    `Error: ${error.message}`, 
                    "", 
                    5000
                );
            }
            
            console.error('=== FIN ERROR ===');
        } finally {
            setIsPrinting(false);
        }
    };

    const searchAction = (credentialValue) => {
        // Resetear estados al inicio de cada búsqueda
        setShowTable(false);
        setSelectedFormulario(null);
        setData(null);
        setToPay(0);
        setIdentificacion(credentialValue); // NUEVO: Guardar identificación

        GeneralService.getDebts(credentialValue).then(result => {
            if (typeof result.data.status !== "undefined") {
                const mensaje = result.data.status.msg || "";

                if (mensaje.toUpperCase().includes("NO TIENE DEUDAS") ||
                    mensaje.toUpperCase().includes("SIN DEUDAS")) {
                    setData([]);
                    setToPay(0);
                    setShowTable(true);
                    NotificationManager.success(mensaje, "", 3000);
                } else {
                    NotificationManager.error(mensaje, "", 5000);
                }
            }
            else {
                NotificationManager.warning("EL CONTRIBUYENTE TIENE DEUDAS", "", 5000);
                setData(result.data);
                let calculatedValue = 0;
                result.data.forEach(record => {
                    calculatedValue = calculatedValue + Number.parseFloat(record.trcValorEmitido);
                });
                setToPay(calculatedValue);
                setShowTable(true);
            }
        }, error => {
            NotificationManager.error("Error en consulta por favor intente más tarde.", "", 5000, () => { });
        });
    }

    return (
        <React.Fragment>
            <Panel header={"Estado de Cuenta al: " + moment().format("YYYY-MM-DD")} style={{ maxWidth: "100%" }}>
                <SearchArea searchAction={searchAction} />
            </Panel>

            <table>
                <tbody>
                    <tr>
                        <td>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <ul>
                                                                <h3><b>REALICE SUS PAGOS MEDIANTE LA BANCA WEB (DISPONIBLE TODOS LOS DIAS DE 10HAM A 10HPM)</b></h3>
                                                                <li><h5>BANCA VIRTUAL BANCO PICHINCHA, Opción PAGAR SERVICIOS, Búscanos como GAD PEDRO VICENTE M, De inmediato se mostrará el valor a pagar HACER CLIC en PAGAR  (Tu pago se verá reflejado al siguiente día y recibirás tu factura al correo registrado). </h5></li>
                                                                <li>Para pago de agua colocar Cuenta de Usuario y para Impuestos colocar número de cedula </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <ul>
                                                                <h3><b>REALICE SUS PAGOS MEDIANTE RED (DISPONIBLE LAS 24 HRS)</b></h3>
                                                                <li><h5>RED FACILITO</h5> </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <ul>
                                                                <h3><b>REALICE SUS PAGOS DE MANERA PRESENCIAL (De lunes a viernes de 08h a 16hpm)</b></h3>
                                                                <li><h5>Ventanilla de recaudación de las Oficinas del GADMPVM</h5></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <ul>
                                                                <h3><b>UTILIZA NUESTRO WHATSAPP 0986929523 PARA REPORTAR TUS PAGOS REALIZADOS MEDIANTE TRANSFERENCIA BANCARIA.</b></h3>
                                                                <li><h5>Sólo mensajes, coloca datos del contribuyente y el detalle del tributo pagado.</h5></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <ul>
                                                                <li><h5><b>DEPOSITOS O TRANSFERENCIA:</b> BANCO PICHINCHA</h5></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <ul>
                                                                <li><h5><b>CUENTA CORRIENTE:</b> 3247002304</h5></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <ul>
                                                                <li><h5><b>BENFICIARIO:</b> GADMPVM</h5></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <ul>
                                                                <li><h5><b>RUC:</b> 1760009530001</h5></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <ul>
                                                                <li><h5><b>SUBLINEA:</b> 30200 EN CASO DE DEPOSITO</h5></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                        <td>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <ul>
                                                                <li><h5><b>CORREO:</b> tesoreria@pedrovicentemaldonado.gob.ec</h5></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <ul>
                                                                <li><h5><b>TELEFONOS:</b> 2392282 / 2392283 EXT 217</h5></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <ul>
                                                                <li><h5><b>IMPORTANTE.-</b> Enviar número de cédula o  RUC del propietario del predio para registrar su pago.</h5></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <ul>
                                                                <li><h5><b>NOTA.- </b>Si sus datos no constan en la consulta, deberá acercarse con su cedula de identidad al área de Avalúos y Catastros, para actualizar sus datos.</h5></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table>
                <tbody>
                    <tr>
                        <td align='center'><h3><b>&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;
                            &#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;
                            Recuerda que: Los pagos realizados mediante transferencia bancaria, deben ser reportados oportunamente al canal de whatsapp, caso contrario, se te sumará el pago de intereses.</b></h3></td>
                    </tr>
                </tbody>
            </table>

            <br />

            {/* Mostrar formularios SIEMPRE que se haya realizado una búsqueda */}
            {showTable && (
                <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                    <Button
                        className={classes.printButton}
                        variant="contained"
                        startIcon={<DescriptionIcon />}
                        onClick={handleMenuOpen}
                    >
                        Seleccionar Formulario
                    </Button>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                        PaperProps={{
                            style: {
                                maxHeight: 400,
                                width: '450px',
                            },
                        }}
                    >
                        {formulariosDisponibles.map((formulario) => (
                            <MenuItem
                                key={formulario.id}
                                onClick={() => handleFormularioSelect(formulario)}
                                selected={selectedFormulario?.id === formulario.id}
                            >
                                {formulario.nombre}
                            </MenuItem>
                        ))}
                    </Menu>
                </div>
            )}

            {/* Mostrar formulario seleccionado SIEMPRE que se haya realizado una búsqueda */}
            {showTable && selectedFormulario && (
                <div className={classes.selectedFormContainer}>
                    <div className={classes.formInfo}>
                        <DescriptionIcon style={{ color: '#3C8DBC', fontSize: 32 }} />
                        <div>
                            <h4 style={{ margin: 0 }}>Formulario seleccionado:</h4>
                            <p style={{ margin: '5px 0 0 0', color: '#666' }}>
                                {selectedFormulario.nombre} (Código: {selectedFormulario.sigla})
                            </p>
                        </div>
                    </div>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<PrintIcon />}
                        onClick={handlePrintFormulario}
                        disabled={isPrinting}
                        style={{
                            backgroundColor: '#4CAF50',
                            minWidth: '150px'
                        }}
                    >
                        {isPrinting ? 'Procesando...' : 'Imprimir Formato'}
                    </Button>
                </div>
            )}

            <Panel header={"Valor Total: $" + toPay.toFixed(2).toString()} style={{ maxWidth: "100%", fontSize: "25px" }}>
                {showTable && data && data.length > 0 &&
                    <TableContainer component={Paper}>
                        <Table className={classes.table} aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align="left">NOMBRE</StyledTableCell>
                                    <StyledTableCell align="left">Tributo</StyledTableCell>
                                    <StyledTableCell align="left">Clave Catastral</StyledTableCell>
                                    <StyledTableCell align="left">Valor Emitido</StyledTableCell>
                                    <StyledTableCell align="left">Descuento</StyledTableCell>
                                    <StyledTableCell align="left">Recargo</StyledTableCell>
                                    <StyledTableCell align="left">Interes</StyledTableCell>
                                    <StyledTableCell align="left">Total</StyledTableCell>
                                    <StyledTableCell align="left">Estado</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.map((row) => (
                                    <StyledTableRow key={row.hegClaveCatastral}>
                                        <StyledTableCell align="left">{row.proApellido} {row.proNombre}</StyledTableCell>
                                        <StyledTableCell align="left">{row.trbNombre}</StyledTableCell>
                                        <StyledTableCell align="left">{row.hegClaveCatastral}</StyledTableCell>
                                        <StyledTableCell align="left">${row.trc_total_cobro}</StyledTableCell>
                                        <StyledTableCell align="left">${row.trc_valor_descuento}</StyledTableCell>
                                        <StyledTableCell align="left">${row.trc_valor_recargo}</StyledTableCell>
                                        <StyledTableCell align="left">${row.trc_valor_interes}</StyledTableCell>
                                        <StyledTableCell align="left">${row.trcValorEmitido}</StyledTableCell>
                                        <StyledTableCell align="left">{row.estado}</StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
                {/* Mensaje cuando no hay deudas */}
                {showTable && data && data.length === 0 && (
                    <div style={{ textAlign: 'center', padding: '40px', color: '#4CAF50' }}>
                        <h3>✓ El contribuyente no tiene deudas pendientes</h3>
                        <p>Puede seleccionar un formulario para imprimir si lo necesita.</p>
                    </div>
                )}
            </Panel>
        </React.Fragment>
    );
}